import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { fetchStitchingReturnlist,fetchSaleOrderDetails } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectKajeEmplist, selectKajeMemoNo, selectStitchReturn, selectStitchReturnMemo,selectKajeSaleOrderList,selectKajeSoData } from '../Selectors/StitchSelector/StitchingSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { KajeMenu } from '../TitleList';
import { fetchKajeEmplist, fetchKajeMemoNo, fetchStitchReturnMemo, kajeEntry,fetchSaleOrderList } from '../../Store/PHPSlice/Kaje/KajeApi';

const KajeEntry = () => {

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        orderType:'stitchingReturn',
        sreId:'',
        sreMemo: '',
        kajeMemo: '',
        item: '',
        itemId: '',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        totQty: '',
        instructions: '',
        userId: '1',
    });
    const [errors, setErrors] = useState({});
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [itemData, setItemData] = useState([]);
    const [balQtyValues, setBalQtyValues] = useState(Array(itemData?.length).fill('0'));
    const [issueQtyValues, setIssueQtyValues] = useState(Array(itemData?.length).fill('0'));
    const actionMap = {
        master: fetchStitchingReturnlist,
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const returnMemo = useSelector(selectStitchReturnMemo);
    const kjemplist = useSelector(selectKajeEmplist);
    const sreMemoNo = useSelector(selectKajeMemoNo);
    const stReturndata = useSelector(selectStitchReturn);
    const kajeSoData=useSelector(selectKajeSoData);
    const saleOrderList=useSelector(selectKajeSaleOrderList);

    useEffect(() => {
        dispatch(fetchKajeMemoNo());
        dispatch(fetchStitchReturnMemo());
        dispatch(fetchKajeEmplist());
         dispatch(fetchSaleOrderList());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (sreMemoNo.data) {
            const item = sreMemoNo.data.kajeNo;
            setFormData(prev => ({
                ...prev,
                kajeMemo: item
            }))
        }
    }, [sreMemoNo]);


    useEffect(() => {
        if (issueQtyValues.length > 0) {
            const sum_issueqty = issueQtyValues.reduce((sum, qty) => sum + parseFloat(qty), 0);
            setFormData(prev => ({
                ...prev,
                totQty: sum_issueqty
            }))
        }
    }, [issueQtyValues]);
    
    useEffect(() => {
        if (stReturndata?.data?.length > 0) {
            const item = stReturndata.data[0];
            setFormData(prev => ({
                ...prev,
                sreId: item.ID,
                itemId: item.itemId,
                item: item.itemNm,
                mcloth: item.mcloth,
                mclothNm: item.mclothNm,
                m1cloth: item.m1cloth,
                m1clothNm: item.m1clothNm,
                m2cloth: item.m2cloth,
                m2clothNm: item.m2clothNm,
                m3cloth: item.m3cloth,
                m3clothNm: item.m3clothNm,
                soId: item.soId,
                sono: item.sono,
                reMemoNo: item.reMemo
            }))
        }
        if (stReturndata.Info.length > 0) {
            const item = stReturndata.Info;
            setItemData(item);
        }
    }, [stReturndata]);
    useEffect(() => {
    if (kajeSoData?.data?.length > 0) {
        const item = kajeSoData.data[0];

        setFormData(prev => ({
            ...prev,
            sreId: item.ID,
            itemId: item.itemId,
            item: item.itemNm,
            mcloth: item.mcloth,
            mclothNm: item.mclothNm,
            m1cloth: item.m1cloth,
            m1clothNm: item.m1clothNm,
            m2cloth: item.m2cloth,
            m2clothNm: item.m2clothNm,
            m3cloth: item.m3cloth,
            m3clothNm: item.m3clothNm,
            soId: item.soId,
            sono: item.sono,
            reMemoNo: item.reMemo
        }));
    }

    if (kajeSoData?.Info?.length > 0) {
        setItemData(kajeSoData.Info);
    } else {
        setItemData([]);
    }
}, [kajeSoData]);
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };
    const handleOrderTypeChange = (e) => {
    const selectedType = e.target.value;

    setFormData((prev) => ({
        ...prev,
        orderType: selectedType,

        // Reset related fields
        reMemo: '',
        sono: '',
        soId: '',
        item: '',
        itemId: '',
    }));

    setItemData([]);
};
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        // switch (dropdownType) {
        //     case 'reMemo':
        //         if (value) {
        //             dispatch(fetchStitchingReturnlist(value));
        //         } else {
        //             setItemData([]);
        //             setFormData({
        //                 sono: '',
        //                 soId: '',
        //                 empNm: '',
        //                 item: '',
        //                 itemId: '',
        //                 mcloth: '',
        //                 m1cloth: '',
        //                 m2cloth: '',
        //                 m3cloth: '',
        //                 mclothNm: '',
        //                 m1clothNm: '',
        //                 m2clothNm: '',
        //                 m3clothNm: '',
        //             })
        //         }
        //         break;
        //     default:
        //         break;
        // }
        switch (dropdownType) {
    case 'reMemo':
        if (value) {
            dispatch(fetchStitchingReturnlist(value));
        } else {
            setItemData([]);
        }
        break;

    case 'saleOrder':
        if (value) {
            dispatch(fetchSaleOrderDetails(value));
        } else {
            setItemData([]);
        }
        break;

    default:
        break;
}
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleQtyChange = (type, index, value) => {
        // Allow only numeric values
        if (/^\d*$/.test(value)) {
            let updatedValues;
            switch (type) {
                case 'issue':
                    // Ensure value is not greater than itemData value
                    if (parseInt(value, 10) <= itemData[index].rbqty) {
                        updatedValues = [...issueQtyValues];
                        updatedValues[index] = value;
                        setIssueQtyValues(updatedValues);

                        // Update balance values based on the new issue quantity
                        const newBalQtyValues = [...balQtyValues];
                        newBalQtyValues[index] = itemData[index].rbqty - parseInt(value, 10);
                        setBalQtyValues(newBalQtyValues);
                    } else {
                        alert(`Entered value cannot be greater than ${itemData[index].rbqty}`);
                    }
                    break;
                default:
                    break;
            }
        }
    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    const validate = () => {
        const newErrors = {};
        if (!formData.firm) newErrors.firm = 'firm is required';
        if (!formData.challanNo) newErrors.challanNo = 'challanNo is required';
        if (!formData.sono) newErrors.sono = 'Sale Order No is required';
        if (!formData.category) newErrors.category = 'category is required';
        if (!formData.empNm) newErrors.empNm = 'empNm is required';
        if (!formData.totMtr) newErrors.totMtr = 'totMtr is required';
        return newErrors;
    };

    function convertIntoOneObject(formData, issueQtyValues, balQtyValues, itemData) {
        const data = {
            orderType: formData.orderType,
            sreId: formData.sreId,
            dt: formData.dt,
            sreMemo: formData.reMemoNo,
            kjMemo: formData.kajeMemo,
            soId: formData.soId,
            empId: formData.empNm,
            itemId: formData.itemId,
            mcloth: formData.mcloth,
            m1cloth: formData.m1cloth || '0',
            m2cloth: formData.m2cloth || '0',
            m3cloth: formData.m3cloth || '0',
            totQty: formData.totQty || '0',
            sreqty: itemData.map(item => item.rqty),
            size: itemData.map(item => item.size),
            issqty: issueQtyValues,
            balqty: balQtyValues,
            instruction: formData.instructions,
            userId: formData.userId,
        }
        return data;
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
            if (!formData.empNm || formData.empNm === '') {
        alert("Please select Master Name");
        return;
    }
        const finalObject = convertIntoOneObject(formData, issueQtyValues, balQtyValues, itemData);
        // console.log(finalObject)

        dispatch(kajeEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Kaje Added");
                window.location.reload();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };

    return (
        <>
            <TitleBar data={KajeMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Kaje Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Kaje Memo', name: 'kajeMemo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={6} >
    <Grid container alignItems="center" spacing={1}>
        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
            <FormLabel>Order Type:</FormLabel>
        </Grid>

        <Grid item xs>
            <RadioGroup
                row
                name="orderType"
                value={formData.orderType}
                onChange={handleOrderTypeChange}
            >
                <FormControlLabel
                    value="stitchingReturn"
                    control={<Radio />}
                    label="Stitching RT Memo"
                />

                <FormControlLabel
                    value="saleOrder"
                    control={<Radio />}
                    label="Direct SO"
                />
            </RadioGroup>
        </Grid>
    </Grid>
</Grid>


                                {formData.orderType === 'stitchingReturn' && (    
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="reMemo">Stitching Return No.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="reMemo"
                                                    name="reMemo"
                                                  //  options={Array.isArray(returnMemo?.data) ? returnMemo.data : []}
                                                   options={Array.isArray(returnMemo?.pstMemo)
    ? returnMemo.pstMemo
    : []
}
                                                    getOptionLabel={(option) => option.reMemo || ''}
                                                 //   value={returnMemo?.data?.find(item => item.ID === formData.reMemo) || null}
                                                 value={
    returnMemo?.pstMemo?.find(
        item => String(item.ID) === String(formData.sreMemo)
    ) || null
}  
                                                 onChange={(event, newValue) => handleDropdownChange({ target: { name: 'sreMemo', value: newValue ? newValue.ID : '' } }, 'reMemo')}
                                                    // onOpen={() => handleDropdownOpen('reMemo')}
                                                    // onClose={() => handleDropdownClose('reMemo')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            // label="Select an option"
                                                            variant="outlined"
                                                            placeholder='Select an option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                )}
                                {formData.orderType === 'saleOrder' && (
    <Grid item xs={12} md={6}>
        <Grid container alignItems="center" spacing={1}>
            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                <InputLabel id="saleOrder">
                    Sale Order No.:
                </InputLabel>
            </Grid>

            <Grid item xs>
                <FormControl fullWidth>
                    <Autocomplete
                        id="saleOrder"
                        name="saleOrder"
                        options={saleOrderList?.data || []}
                        getOptionLabel={(option) =>
                            option.sono || ''
                        }
                        value={
                            saleOrderList?.data?.find(
                                item => item.ID === formData.soId
                            ) || null
                        }
                        onChange={(event, newValue) =>
                            handleDropdownChange(
                                {
                                    target: {
                                        name: 'saleOrder',
                                        value: newValue
                                            ? newValue.ID
                                            : '',
                                    },
                                },
                                'saleOrder'
                            )
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Sale Order"
                                sx={{
                                    ...inputStyles,
                                    '& .MuiInputBase-root': {
                                        height: '35px',
                                    },
                                }}
                            />
                        )}
                        isOptionEqualToValue={(option, value) =>
                            option.ID === value.ID
                        }
                    />
                </FormControl>
            </Grid>
        </Grid>
    </Grid>
)}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="empNm">Master Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="empNm"
                                                    name="empNm"
                                                    options={kjemplist?.data}
                                                    getOptionLabel={(option) => option.empNm || ''}
                                                    value={kjemplist?.data?.find(item => item.ID === formData.empNm) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'empNm', value: newValue ? newValue.ID : '' } }, 'empNm')}
                                                    onOpen={() => handleDropdownOpen('empNm')}
                                                    onClose={() => handleDropdownClose('empNm')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            // label="Select an option"
                                                            variant="outlined"
                                                            placeholder='Select an option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='item'>Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Typography
                                                    id='item'
                                                >
                                                    {formData.item || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                                {errors.item && <FormHelperText style={errorStyles}>{errors.item}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.soId !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='sono'>SO No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='sono'
                                                    >
                                                        {formData.sono || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.sono && <FormHelperText style={errorStyles}>{errors.sono}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mclothNm'>Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Typography
                                                    id='mclothNm'
                                                >
                                                    {formData.mclothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                                {errors.mclothNm && <FormHelperText style={errorStyles}>{errors.mclothNm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.m1cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m1clothNm'>Matching-1:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='m1clothNm'
                                                    >
                                                        {formData.m1clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.m1clothNm && <FormHelperText style={errorStyles}>{errors.m1clothNm}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.m2cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m2clothNm'>Matching-2:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='m2clothNm'
                                                    >
                                                        {formData.m2clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.m2clothNm && <FormHelperText style={errorStyles}>{errors.m2clothNm}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.m3cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m1clothNm'>Matching-3:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='m3clothNm'
                                                    >
                                                        {formData.m3clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                            
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {itemData.length > 0 &&
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Size</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.size}</TableCell>
                                                    )) : null}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Qty.</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.rqty}</TableCell>
                                                    )) : null}
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={issueQtyValues[index] || '0'}
                                                                onChange={(e) => handleQtyChange('issue', index, e.target.value)}
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Bal Qty.</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            {balQtyValues[index] || '0'}
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }

                                {[
                                    { label: 'Kaje Instructions', name: 'instructions' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        style={{ ...styled.input, width: '100%' }}
                                                        readOnly={field.type === 'readOnly'}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default KajeEntry;
